export class SmartTagResetOperations {
    #deps;
    constructor(deps) {
        this.#deps = deps;
    }
    resetTags = () => {
        this.#deps.logger.log('reset:');
        return new Promise((resolve, reject) => {
            const tagsToReset = this.#getTagsToReset();
            if (tagsToReset.length === 0) {
                this.#cleanupEmptyRegistry();
                resolve({ msg: 'Success: no tags to remove.' });
                return;
            }
            this.#resetTagsBatch(tagsToReset, resolve, reject);
        });
    };
    #getTagsToReset() {
        const registry = this.#deps.getRegistry();
        return Object.keys(registry).map((key) => ({
            key,
            tag: registry[key]
        }));
    }
    #cleanupEmptyRegistry() {
        this.#deps.setList([]);
        this.#deps.setRegistry({});
    }
    #resetTagsBatch(tagsToReset, resolve, reject) {
        const resetPromises = tagsToReset.map(({ key, tag }) => this.#createResetPromise(key, tag));
        Promise.all(resetPromises).then((results) => this.#processResetResults(results, resolve)).catch((error) => {
            this.#deps.logger.error('reset:', 'Unexpected error in Promise.all:', error);
            reject({ msg: 'Failure: unexpected error during reset.', error });
        });
    }
    #createResetPromise(key, tag) {
        if (!tag?.API?.TAG?.reset || !this.#deps.utilities?.Type?.isFunction?.(tag?.API?.TAG?.reset)) {
            return Promise.resolve({
                success: false,
                key,
                tag,
                error: 'Tag reset method not available'
            });
        }
        return tag.API.TAG.reset().then((data) => {
            this.#deps.logger.log('reset:', 'Tag.reset():', data);
            return {
                success: true,
                key,
                tag,
                data
            };
        }).catch((error) => {
            this.#deps.logger.warn('reset:', 'Tag.reset() failed:', error);
            return {
                success: false,
                key,
                tag,
                error
            };
        });
    }
    #processResetResults(results, resolve) {
        const successfulResets = [];
        const failedResets = [];
        results.forEach((result) => {
            if (result.success) {
                this.#removeTagFromCollections(result.tag);
                successfulResets.push(result);
            }
            else {
                failedResets.push(result);
            }
        });
        this.#cleanupEmptyRegistry();
        this.#resolveResetResults(successfulResets, failedResets, resolve);
    }
    #removeTagFromCollections(tag) {
        if (!this.#deps.utilities?.Array?.indexOf) {
            this.#deps.logger.warn('removeTagFromCollections:', 'Array utilities not available');
            this.#deps.removeFromRegistry(tag.uuid);
            return;
        }
        const list = this.#deps.getList();
        if (list) {
            const indexToDelete = this.#deps.utilities.Array.indexOf('uuid', tag.uuid, list);
            if (indexToDelete !== null && indexToDelete !== undefined) {
                this.#deps.removeFromList(tag.uuid);
            }
        }
        this.#deps.removeFromRegistry(tag.uuid);
    }
    #resolveResetResults(successfulResets, failedResets, resolve) {
        this.#deps.logger.log('reset:', `Completed: ${successfulResets.length} successful, ${failedResets.length} failed`);
        if (failedResets.length === 0) {
            resolve({
                msg: 'Success: all tags removed.',
                data: { successful: successfulResets.length }
            });
        }
        else {
            resolve({
                msg: `Partial success: ${successfulResets.length} removed, ${failedResets.length} failed.`,
                data: {
                    successful: successfulResets.length,
                    failed: failedResets.length,
                    errors: failedResets.map((r) => r.error)
                }
            });
        }
    }
}
